import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../../../../SetupAndBorrower/Setup/functions/isRequiredOnceNoteDated';
import { toPositiveNumber } from './functions/toPositiveNumber';

/** For a Bridge loan with "Same as Committed" checked, this also sets Apprvd Loan Amt and Bridge Funded. */
export const PromissoryNoteField = () => {
    const value = useStandardLoanStore((state) => state.loan.promissoryNote);
    const setup = useStandardLoanStore((state) => state.setup);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanPromissoryNote'
            value={value}
            onChange={(amount) => updateLoan({ promissoryNote: toPositiveNumber(amount) })}
            label='Prom. Note/Com.'
            required={isRequiredOnceNoteDated(setup)}
            displayChange={true}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
